/*
 * @Author: lzy
 * @Date: 2019-11-13 11:19:08
 * @LastEditTime: 2021-05-19 14:38:32
 * @LastEditors: cc
 * @Description: 头条号
 * @FilePath: \xjmediacloud\app\editingCenter\toutiaohao\toutiaohao.js
 */
angular.module('editCenterToutiaohaoModule', [
    'editToutiaohaoLeftModule',
    'toutiaohaoRouterModule',
    'editToutiaohaoToBeCompiledModule',
    'editToutiaoToBeCompiledNewsModule',
    'editingCenterToutiaohaoVideoModule',
    'editToutiaohaoToBeCompiledRouterModule',
    'toutiaohaoServiceModule',
    'editToutiaohaoPendingModule',
    'editToutiaohaoPendingRouterModule',
    'editToutiaohaoSignedRouterModule',
    'editToutiaohaoSignedModule',
    'editToutiaohaoDraftBoxRouterModule',
    'editToutiaohaoDraftBoxModule',
]).controller('editCenterToutiaohaoCtrl', [function () {

}]).value('toutConst', {
    listenStroageKey: 'Toutiaohao', // 监听缓存的名称
    // idName: 'KUAIBAOARTICLEID', // 主要使用的ID名称
    docTypeCheck: {
        // 稿件类型判断
        1: 'toutiaohaonews',
        7: 'toutiaohaovideo',
    },
    trial: {
        // 送审参数
        serviceid: 'mlf_toutiaooper',
        methodname: 'trialTouTiaoArticles',
    },
    kill: {
        // 撤稿参数
        serviceid: 'mlf_toutiaooper',
        methodName: 'withdrawTouTiaoArticles',
    },
    signOfDaibian: {
        // 签发参数
        serviceid: 'mlf_toutiaooper',
        methodname: 'touTiaoDaiBianPublish',
    },
    signOfDaishen: {
        // 签发参数
        serviceid: 'mlf_toutiaooper',
        methodname: 'touTiaoDaiShenPublish',
    },
    waste: {
        // 废稿参数
        serviceid: 'mlf_toutiaooper',
        methodname: 'abolishDaiBianArticles',
    },
    export: {
        // 导出参数
        serviceid: 'mlf_exportword',
        methodname: 'exportWordFile',
    },
    outsource: {
        // 外发参数
        serviceid: 'mlf_mailoutgoingOper',
        methodname: 'touTiaoDaiBianFaSendEmail',
    },
    retraction: {
        // 取消签发参数
        serviceid: 'mlf_toutiaooper',
        methodname: 'cancelTouTiaoArticles',
    },
    draftlistDaiBian: {
        // 发稿单待编参数1
        serviceid: 'mlf_appfgd',
        methodname: 'touTiaoDaiBianbatchUpdateFgdUsers',
    },
    draftlist: {
        // 发稿单查询参数
        serviceid: 'mlf_appfgd',
        methodname: 'queryFgdByMetaDataId',
    },
    draftlistDaiShen: {
        // 发稿单待编参数1
        serviceid: 'mlf_appfgd',
        methodname: 'touTiaoDaiShenbatchUpdateFgdUsers',
    },
    // graph: {
    //     // 图示参数
    //     serviceid: 'mlf_kuaibaoarticle',
    //     methodname: 'queryAllImgLogo',
    // },
});
